import { useState } from "react";
import { CardFrame } from "../../../../../common/components/card-frame/CardFrame";
import { ChevronRightIcon, WalletIcon } from "../../../../../assets/icons";
import { CardHeaderRow } from "./CardHeaderRow";
import { NumberInputRow } from "./NumberInputRow";
import { PaymentMethodSheet } from "./PaymentMethodSheet";
import styles from "../unit-threshold-setup.module.scss";

interface AutoRechargeCardProps {
	autoRechargeOn: boolean;
	rechargeAmountInput: number | null;
	autoRechargeSaved: boolean;
	paymentMethodId: string | null;
	paymentMethodLabel: string | null;
	paymentMethodSubtitle: string | null;
	isSaving: boolean;
	disabled?: boolean;
	onToggleAutoRecharge: (val: boolean) => void;
	onAmountChange: (val: number) => void;
	onSelectPaymentMethod: (id: string, label: string, subtitle: string) => void;
	onSave: () => void;
}

export const AutoRechargeCard = ({
	autoRechargeOn,
	rechargeAmountInput,
	autoRechargeSaved,
	paymentMethodId,
	paymentMethodLabel,
	paymentMethodSubtitle,
	isSaving,
	disabled,
	onToggleAutoRecharge,
	onAmountChange,
	onSelectPaymentMethod,
	onSave,
}: AutoRechargeCardProps) => {
	const [showPaymentSheet, setShowPaymentSheet] = useState(false);

	const canSave =
		autoRechargeOn &&
		rechargeAmountInput != null &&
		rechargeAmountInput > 0 &&
		paymentMethodLabel != null;

	return (
		<>
			<CardFrame>
				<CardHeaderRow
					title="Auto Recharge"
					subtitle="Automatically buy units when threshold is reached"
					isOn={autoRechargeOn}
					disabled={disabled}
					onToggle={onToggleAutoRecharge}
				/>
				{autoRechargeOn && (
					<div className={styles.cardBody}>
						<NumberInputRow
							label="Recharge Amount"
							value={rechargeAmountInput}
							currencyPrefix="₦"
							step={100}
							isSaved={autoRechargeSaved}
							isSaving={isSaving}
							canSave={canSave}
							onChange={onAmountChange}
							onSave={onSave}
							plusMinus={true}
						/>
						<div className={styles.paymentPickerSection}>
							<span className={styles.inputLabel}>Payment Method</span>
							<button
								className={`${styles.paymentPickerButton} ${!rechargeAmountInput ? styles.paymentPickerDisabled : ""}`}
								onClick={() => rechargeAmountInput && setShowPaymentSheet(true)}
								disabled={!rechargeAmountInput}
							>
								<div className={styles.paymentPickerIcon}>
									<WalletIcon width={20} height={20} />
								</div>
								<div className={styles.paymentPickerContent}>
									<span className={styles.paymentPickerLabel}>{paymentMethodLabel ?? "Select Payment Method"}</span>
									{paymentMethodSubtitle && <span className={styles.paymentPickerSubtitle}>{paymentMethodSubtitle}</span>}
								</div>
								<ChevronRightIcon width={22} height={22} className={styles.paymentPickerChevron} />
							</button>
						</div>
					</div>
				)}
			</CardFrame>

			{showPaymentSheet && (
				<PaymentMethodSheet
					selectedId={paymentMethodId}
					onSelect={(id, label, subtitle) => {
						onSelectPaymentMethod(id, label, subtitle);
						setShowPaymentSheet(false);
					}}
					onClose={() => setShowPaymentSheet(false)}
				/>
			)}
		</>
	);
};
